import { render, staticRenderFns } from "./ApprovedBudgetApplicationDetail.vue?vue&type=template&id=0b5a8de0&"
import script from "./ApprovedBudgetApplicationDetail.vue?vue&type=script&lang=js&"
export * from "./ApprovedBudgetApplicationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports